import { createAsyncThunk } from '@reduxjs/toolkit';
import { scheduleProjectMediaTagsRefresh } from 'store/mediaTags/thunks/scheduleProjectMediaTagsRefresh.thunk';
import { postMediaFilePermissionToProjectBank } from '../services/postMediaFilePermissionToProjectBank.service';

export const createMediaFilePermissionToProjectBank = createAsyncThunk(
  'file-permissions/project/images',
  async (
    {
      projectId,
      name,
      s3FileName,
      contentType,
      recordId,
      assignmentId,
      mediaTagsToAdd,
      // Set by the invoice-scan path, whose photos are already in S3 under the
      // temp scan prefix: the backend moves them across instead of taking a
      // second upload of the same bytes from the phone.
      copyFromTempInvoiceImages,
    },
    { dispatch }
  ) => {
    const response = await postMediaFilePermissionToProjectBank({
      projectId,
      name,
      s3FileName,
      contentType,
      recordId,
      assignmentId,
      mediaTagsToAdd,
      copyFromTempInvoiceImages,
    });
    console.log('response', response);

    // The AI tagger tags a filed photo a few seconds from now, after the
    // gallery has read the project's tags. Videos are never tagged.
    if (!contentType?.startsWith('video/')) {
      dispatch(scheduleProjectMediaTagsRefresh(projectId));
    }

    return response;
  }
);
